
<template>
  <div id="product">
    <div class="banner">
      <img src="@/assets/product/Product Center.png" alt>
    </div>
    <div class="text1 inner">
      <p>共享/无人自助机</p>
      <p>&mdash;&nbsp;Shared / unmanned self service machine&nbsp;&mdash;</p>
    </div>
    <div class="machine inner">
      <div class="machineLeft clearfix" v-for="item in productList" :key="item.id">
        <div class="fl">
          <p>{{item.tit}}</p>
          <p>{{item.content}}</p>
          <p @click="click(item.id)">{{item.promptly}}</p>
        </div>
        <img class="fr" :src="item.url" alt="">
      </div>
    </div>
    <div class="text inner">
      <p>租赁机型</p>
      <p>&mdash;&nbsp;Rental model&nbsp;&mdash;</p>
    </div>
    <!-- 轮播 -->
    <el-carousel arrow='always' trigger="click" indicator-position="none" :autoplay='false' class="topBanner inner" height="490px">
      <el-carousel-item class="lease" v-for="item in 3" :key="item">
        <div class="leaseCon inner" v-for="item in machine" :key="item.id">
        <div class="imgwrap">
            <img :src="item.url" alt="">
        </div>
          <div class="leaseBoot">
            <p>{{item.content}}</p>
            <p @click="click(item.id)">{{item.buy}}</p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="fabricate">
      <div class="text inner">
        <p>再制造机型</p>
        <p>&mdash;&nbsp;Remanufactured model&nbsp;&mdash;</p>
      </div>
      <div class="fabricateTop inner">
        <div>
          <p>东芝2010AC 彩色数码复合机 适用30-60办公</p>
          <p>
            打印/复印/扫描/双面打印<br>免印量黑白2000张/月<br>彩色200张/月<br>超印：黑白0.05元/页,彩色0.5元/页
          </p>
          <p @click="click(8)">立即前往</p>
        </div>
        <img src="@/assets/product/productbg2.png" alt="">
      </div>
      <ul class="fabricateBott inner">
        <li v-for="item in fabricateBottList" :key="item.id">{{item.content}}</li>
      </ul>
    </div>
    <footerPage></footerPage>
  </div>
</template>
<script>
import '@/css/product.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
  data() {
    return {
      productList: [
        {
          id: 1, url: require("@/assets/product/11233815.png"), tit: '政务星', content: '“沐之盛智慧云文印”自助终端，是沐之盛信息科技有限公司旗下的一款自助打印设备，该产品完全打破了传统打印的方式，颠覆了行业规则。',
          promptly: '立即前往'
        },
        {
          id: 2, url: require("@/assets/product/11233816.png"), tit: '作业星', content: '“沐之盛智慧云文印”自助终端，是沐之盛信息科技有限公司旗下的一款自助打印设备，该产品完全打破了传统打印的方式，颠覆了行业规则。',
          promptly: '立即前往'
        }
      ],
      machine: [
        {
          id: 0, url: require("@/assets/product/equipment.png"), buy: '立即前往', content: '东芝2010AC 彩色数码复合机 适用30-60办公',
          activity: '全新机促销活动'
        },
        {
          id: 1, url: require("@/assets/product/equipment.png"), buy: '立即前往', content: '东芝2010AC 彩色数码复合机 适用30-60办公',
          activity: '再制造促销活动'
        },
        {
          id: 2, url: require("@/assets/product/equipment.png"), buy: '立即前往', content: '东芝2010AC 彩色数码复合机 适用30-60办公',
          activity: '全新机促销活动'
        }
      ],
      fabricateBottList: [
        {
          id: 1, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 2, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 3, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 4, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 5, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 6, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 7, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },
        {
          id: 8, content: '东芝2010AC 彩色数码 复合机适用30-60办公'
        },

      ],
    }
  },
  methods: {
    click(id) {
      this.$router.push('/ProductDetails/' + id);
    }
  }
};
</script>




